/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Type} from '../type';
import {PlatformReflectionCapabilities} from './platform_reflection_capabilities';
import {GetterFn, MethodFn, SetterFn} from './types';

export {PlatformReflectionCapabilities} from './platform_reflection_capabilities';
export {GetterFn, MethodFn, SetterFn} from './types';
/**
 * Provides access to reflection data about symbols. Used internally by Angular
 * to power dependency injection and compilation.
 */
export class Reflector {
/**
 * @param {?} reflectionCapabilities
 */
constructor(public reflectionCapabilities: PlatformReflectionCapabilities) {}
/**
 * @param {?} caps
 * @return {?}
 */
updateCapabilities(caps: PlatformReflectionCapabilities) { this.reflectionCapabilities = caps; }
/**
 * @param {?} type
 * @return {?}
 */
factory(type: Type<any>): Function { return this.reflectionCapabilities.factory(type); }
/**
 * @param {?} typeOrFunc
 * @return {?}
 */
parameters(typeOrFunc: Type<any>): any[][] {
    return this.reflectionCapabilities.parameters(typeOrFunc);
  }
/**
 * @param {?} typeOrFunc
 * @return {?}
 */
annotations(typeOrFunc: Type<any>): any[] {
    return this.reflectionCapabilities.annotations(typeOrFunc);
  }
/**
 * @param {?} typeOrFunc
 * @return {?}
 */
propMetadata(typeOrFunc: Type<any>): {[key: string]: any[]} {
    return this.reflectionCapabilities.propMetadata(typeOrFunc);
  }
/**
 * @param {?} type
 * @param {?} lcProperty
 * @return {?}
 */
hasLifecycleHook(type: any, lcProperty: string): boolean {
    return this.reflectionCapabilities.hasLifecycleHook(type, lcProperty);
  }
/**
 * @param {?} name
 * @return {?}
 */
getter(name: string): GetterFn { return this.reflectionCapabilities.getter(name); }
/**
 * @param {?} name
 * @return {?}
 */
setter(name: string): SetterFn { return this.reflectionCapabilities.setter(name); }
/**
 * @param {?} name
 * @return {?}
 */
method(name: string): MethodFn { return this.reflectionCapabilities.method(name); }
/**
 * @param {?} type
 * @return {?}
 */
importUri(type: any): string { return this.reflectionCapabilities.importUri(type); }
/**
 * @param {?} type
 * @return {?}
 */
resourceUri(type: any): string { return this.reflectionCapabilities.resourceUri(type); }
/**
 * @param {?} name
 * @param {?} moduleUrl
 * @param {?} members
 * @param {?} runtime
 * @return {?}
 */
resolveIdentifier(name: string, moduleUrl: string, members: string[], runtime: any): any {
    return this.reflectionCapabilities.resolveIdentifier(name, moduleUrl, members, runtime);
  }
/**
 * @param {?} identifier
 * @param {?} name
 * @return {?}
 */
resolveEnum(identifier: any, name: string): any {
    return this.reflectionCapabilities.resolveEnum(identifier, name);
  }
}

function Reflector_tsickle_Closure_declarations() {
/** @type {?} */
Reflector.prototype.reflectionCapabilities;
}




// WEBPACK FOOTER //
// ../../../../packages/core/src/reflection/reflector.ts